import React from 'react';
import AuthBackground from '../assets/images/AuthBackground.png';

const authbackground = () => (
        <img src={AuthBackground} alt="BlueHex"/>        
);


export default authbackground;